module.exports = __webpack_public_path__ + "img/linkedin-ico.5488913d.svg";